import { getItem, objectToList } from "@garantidos/utils"

import isClient from "@mobi/utils/browser/isClient"
import isMobile from "@mobi/utils/browser/isMobile"

import Address from "./Address"
import FinancingConditions from "./FinancingConditions"
import Finished from "./Finished"
import Lead from "./Lead"
import Qualification from "./Qualification"
import RedirectApp from "./RedirectApp"
import Rejection from "./Rejection"
import SimulationWithResults from "./SimulationWithResults"
import Sms from "./Sms"
import Softlead from "./Softlead"
import OneClickSoftLead, {
  CpfOneClick,
  EmailOneClick,
  NameOneClick,
  PhoneNumberOneClick
} from "./SoftleadOneClick"
import Summary from "./Summary"

const cpf = isClient() ? getItem("cpfFromHero") : ""

const steps = {
  "softlead-simulation-cpf": {
    name: "softlead-simulation-cpf",
    component: CpfOneClick,
    stepInfo: {
      title: "dados pessoais",
      index: 1,
      max: 4
    }
  },
  "softlead-simulation-name": {
    name: "softlead-simulation-name",
    component: NameOneClick,
    stepInfo: {
      title: "dados pessoais",
      index: 2,
      max: 4
    }
  },
  "softlead-simulation-email": {
    name: "softlead-simulation-email",
    component: EmailOneClick,
    stepInfo: {
      title: "dados pessoais",
      index: 3,
      max: 4
    }
  },
  "softlead-simulation-phone": {
    name: "softlead-simulation-phone",
    component: PhoneNumberOneClick,
    stepInfo: {
      title: "dados pessoais",
      index: 4,
      max: 4
    }
  },
  softlead: {
    name: "softlead-simulation",
    component: !isMobile ? Softlead : OneClickSoftLead,
    stepInfo: {
      title: "dados pessoais",
      index: !isMobile ? 1 : cpf ? 2 : 1,
      max: !isMobile ? 1 : 4
    }
  },
  rejection: {
    name: "rejection",
    component: Rejection,
    title: "Erro | Crédito com Garantia de Imóvel | Itaú",
    isSplitted: false
  },
  redirectApp: {
    name: "redirect-app",
    component: RedirectApp,
    isSplitted: false
  },
  SimulationWithResults: {
    name: "simulation-with-results",
    component: SimulationWithResults,
    isSplitted: false
  },
  qualification: {
    name: "lead-qualification",
    component: Qualification,
    stepInfo: {
      title: "sobre o imóvel de garantia",
      index: 1,
      max: 6
    }
  },
  lead: {
    name: "proposal-lead",
    component: Lead,
    stepInfo: {
      title: "sobre você",
      index: 2,
      max: 6
    }
  },
  address: {
    name: "proposal-lead-address",
    component: Address,
    stepInfo: {
      title: "endereço",
      index: 3,
      max: 6
    }
  },
  financingConditions: {
    name: "proposal-financing-conditions",
    component: FinancingConditions,
    stepInfo: {
      title: "facilidades",
      index: 4,
      max: 6
    }
  },
  summary: {
    name: "proposal-summary",
    component: Summary,
    stepInfo: {
      title: "resumo",
      index: 5,
      max: 6
    }
  },
  sms: {
    name: "sms-confirmation",
    component: Sms,
    stepInfo: {
      title: "confirmação sms",
      index: 6,
      max: 6
    }
  },
  finished: {
    name: "proposal-finished",
    component: Finished,
    isSplitted: false
  }
}

const apiSteps = Object.fromEntries(
  objectToList(steps).map((step) => [
    step.value.name,
    { name: step.key, component: step.value.component }
  ])
)

export { apiSteps, steps }
